export type TransformedRange = { title: string; openUrl: string };
export type EcommerceApc = {
  availibilityInfo?: Array<{
    price: string;
    id: string;
    availabilityStatus: string;
  }>;
  price: string;
  viewConfiguration?: {
    ShowCallForAvailability: boolean;
    displayPrice: boolean;
    showAddToCart: boolean;
  };
  eShopUrl: string;
};

export type EcommerceSe = {
  price: string;
  availibility?: 'in_stock' | 'out_of_stock';
  eShopUrl: string;
  supportPage?: string;
};

export enum Categories { //eslint-disable-line @stencil-community/ban-exported-const-enums
  //FIXME CONST ENUM JEST ZABRONIONE
  PRODUCT = 'Product',
  PRODUCT_RANGE = 'Product Range',
}

export enum Area { //eslint-disable-line @stencil-community/ban-exported-const-enums
  //FIXME CONST ENUM JEST ZABRONIONE
  TITLE = 'title',
  IMAGE = 'image',
  BUTTON = 'eshop_link',
  PN_BUTTON = 'produktnet_link',
  CHECKBOX = 'checkbox',
  TOOLTIP = 'tooltip',
  DROPDOWN = 'dropdown',
  VIEW_DETAILS = 'view_details'
}

export enum Availibility { //eslint-disable-line @stencil-community/ban-exported-const-enums
  //FIXME CONST ENUM JEST ZABRONIONE
  IN_STOCK = 'in_stock',
  OUT_OF_STOCK = 'OUT_OF_STOCK'
}
